<template>
  <div id="app">
    <nav class="navbar is-light">
      <div class="container">
        <div class="navbar-brand">
          <router-link to="/" exact tag="a" class="navbar-item" @click.native="showNav = false">Mogensen-Boyle
          </router-link>
          <div class="navbar-burger burger" data-target="navMenuWedding"
               @click="showNav = !showNav"
               :class="{ 'is-active': showNav }">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

        <div id="navMenuWedding" class="navbar-menu" :class="{ 'is-active': showNav }">
          <div class="navbar-start">
          </div>

          <div class="navbar-end">
            <router-link to="/photos" tag="a" class="navbar-item" @click.native="showNav = false">Photos
            </router-link>
          </div>
        </div>
      </div>
    </nav>
    <router-view/>
    <footer class="footer">
      <div class="content has-text-centered">
        <p>If you have any questions just send us a message at
          <a href="mailto:wedding@mogensen.xyz" target="_blank">wedding@mogensen.xyz</a> and
          we'll get back to you!</p>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'Story',
  data: () => ({
    showNav: false
  })
}
</script>

<style lang="scss">
  .background-primary {
    background-color: rgba(128, 64, 0, 0.3);
  }

  .background-light {
    background-color:  rgba(128, 64, 0, 0.1);
  }

  .margin-top-10 {
    margin-top: 10px !important;
  }
</style>
